import { TextStyle_TextAlignment } from 'ricos-schema';
import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import {
  TEXT_ALIGNMENT_BUTTON_DATA_HOOK,
  TEXT_ALIGNMENT_CENTER_BUTTON_DATA_HOOK,
  TEXT_ALIGNMENT_JUSTIFY_BUTTON_DATA_HOOK,
  TEXT_ALIGNMENT_LEFT_BUTTON_DATA_HOOK,
  TEXT_ALIGNMENT_RIGHT_BUTTON_DATA_HOOK,
} from './data-hooks';

export type TextAlignTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => {
      getButton: () => Promise<UniDriver<Element>>;
      click: () => Promise<void>;
      getModal: () => Promise<UniDriver<Element>>;
      clickModalValue: (value: TextStyle_TextAlignment) => Promise<void>;
    };
  };
}>;

export const createTextAlignTestkit: TextAlignTestkit = getBase => {
  const options = {
    [TextStyle_TextAlignment.LEFT]: TEXT_ALIGNMENT_LEFT_BUTTON_DATA_HOOK,
    [TextStyle_TextAlignment.CENTER]: TEXT_ALIGNMENT_CENTER_BUTTON_DATA_HOOK,
    [TextStyle_TextAlignment.RIGHT]: TEXT_ALIGNMENT_RIGHT_BUTTON_DATA_HOOK,
    [TextStyle_TextAlignment.JUSTIFY]: TEXT_ALIGNMENT_JUSTIFY_BUTTON_DATA_HOOK,
  };

  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => {
        const getButton = async () =>
          getTextButtonToolbarBase().get(dataHook(TEXT_ALIGNMENT_BUTTON_DATA_HOOK));

        const getModal = async () => getBase().get(dataHook('toolbars-modal-desktopPanel'));

        return {
          getButton,
          getModal,
          click: async () => {
            const button = await getButton();
            await button.click();
          },
          clickModalValue: async value => {
            const modal = await getModal();
            const button = await modal.get(dataHook(options[value]));
            await button.click();
          },
        };
      },
    },
  };
};
